import axios from 'axios';
import { API_URL } from '../config';

export const getInOutsEmployeeList = async (token: string, employeeId: number, fromDate: string, page: number, pageSize: number = 10, toDate: string) => {
    const response = await axios.get(`${API_URL}/presenze/employee/${employeeId}/inouts/`,
        {
            headers: {
                'Authorization': `${token}`,
            },
            params: {
                from_date: fromDate,
                page: page,
                page_size: pageSize,
                to_date: toDate,
            }
        });
    return response.data;
};

export const createEmployeeTimbratura = async (token: string, employeeId: number, data: any) => {
    const response = await axios.post(`${API_URL}/presenze/employee/${employeeId}/inouts/`,
      data,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
};

export const updateEmployeeTimbratura = async (token: string, employeeId: number, inOutId: number, data: any) => {
  const response = await axios.patch(`${API_URL}/presenze/employee/${employeeId}/inouts/${inOutId}/`,
    data,
    {
      headers: {
        'Authorization': token,
      },
    }
  );
  return response.data;
};

export const deleteEmployeeTimbratura = async (token: string, employeeId: number, inOutId: number) => {
  const response = await axios.delete(`${API_URL}/presenze/employee/${employeeId}/inouts/${inOutId}/`,
   {
      headers: {
        'Authorization': `${token}`,
      },
    });
  return response.data;
};

export const getTimbratureWeek = async (
  token: string,
  { startDate, endDate }: { startDate: string, endDate: string },
  selectedUnit: number | null = null,
  selectedEmployees: number[] = [],
  page: number = 1, pageSize: number = 25,
  signal: AbortSignal | null = null,
  permission: string | null,
) => {
  const config: any = {}
  if (signal) 
    config.signal = signal

  if (permission) 
    config.permission = permission

  const response = await axios.get( `${API_URL}/presenze/company/attendance/inouts/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
      params: {
          start_date: startDate,
          end_date: endDate,
          page,
          page_size: pageSize,
          ou: selectedUnit,
          employees: selectedEmployees.join(',')
      },
      ...config, 
    });
  return response.data;
};